


































































import { defineComponent, PropType, computed } from '@vue/composition-api';
import { ASecondaryBtn } from '../../base/app/buttons';
import { BillingData } from '../../../models';
import { useMembershipInfo } from '../../utils/membership-info';

export default defineComponent({
  name: 'SavedBilling',
  components: { ASecondaryBtn },
  props: {
    billing: {
      type: Object as PropType<BillingData>
    },
    showUpdatePaymentButton: {
      type: Boolean
    }
  },
  setup(props) {
    const { hasMembership, subscription } = useMembershipInfo();

    const address = computed(() =>
      !props.billing.street &&
      !props.billing.house_number &&
      !props.billing.city &&
      !props.billing.zip
        ? ''
        : `${props.billing.street} ${props.billing.house_number},  ${props.billing.city}, ${props.billing.zip}`
    );
    return { address, hasMembership, subscription };
  }
});
